import CountUp from 'countup.js';

var numberContent = $('.js-number-container');

function checkVisibility(elem) {
    var myElement = document.getElementById(elem);
    var elementWatcher = scrollMonitor.create(myElement);

    elementWatcher.enterViewport(function() {
        var counterStart = $('#' + elem + '').data('start');
        var counterEnd = $('#' + elem + '').data('end');
        var counterDuration = $('#' + elem + '').data('duration');

        var options = {
            useEasing: true,
            useGrouping: true,
            separator: ',',
            decimal: '.',
        };
        var demo = new CountUp(
            elem,
            counterStart,
            counterEnd,
            0,
            counterDuration,
            options
        );
        if (!demo.error) {
            demo.start();
        } else {
            console.error(demo.error);
        }
    });
    elementWatcher.exitViewport(function() {});
}

function runCounter() {
    if (numberContent.length) {
        console.log('run counter');
        checkVisibility(document.getElementById('js-number-1').id);
        checkVisibility(document.getElementById('js-number-2').id);
        checkVisibility(document.getElementById('js-number-3').id);
    }
}

runCounter();
